import {
  Select
} from '@etherisc/ui-kit';
import { AlertTriangleIcon } from 'lucide-react';

// Helper function for conditional classes
function cn(...classes: (string | undefined | false | null)[]): string {
  return classes.filter(Boolean).join(' ');
}

export interface Organization {
  id: string;
  name: string;
  code: string;
  type: string;
  isActive: boolean;
}

interface OrganizationSelectorProps {
  value: string;
  name: string;
  organizations: Organization[];
  onChange: (organizationId: string, organizationName: string) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  showValidationIcon?: boolean;
}

export function OrganizationSelector({
  value,

  organizations,
  onChange,
  disabled = false,
  placeholder = "Select organization...",
  className,
  showValidationIcon = true
}: OrganizationSelectorProps) {
  // Ensure organizations is always an array
  const organizationsArray = Array.isArray(organizations) ? organizations : [];
  
  const selectedOrg = organizationsArray.find(org => org.id === value);
  const isInvalid = value && !selectedOrg;
  const isInactive = selectedOrg && !selectedOrg.isActive;

  // Filter organizations: active first, then inactive (but still show selected inactive org)
  const sortedOrganizations = organizationsArray
    .filter(org => org.isActive || org.id === value)
    .sort((a, b) => {
      // Active orgs first
      if (a.isActive && !b.isActive) return -1;
      if (!a.isActive && b.isActive) return 1;
      // Then sort by type, then name
      if (a.type !== b.type) return a.type.localeCompare(b.type);
      return a.name.localeCompare(b.name);
    });



      return (
    <div className={cn("flex items-center gap-2", className)}>
      <Select
        value={value}
        onValueChange={(orgId) => {
          const org = organizationsArray.find(o => o.id === orgId);
          onChange(orgId, org?.name || '');
        }}
        disabled={disabled}
        className={cn(
          "min-w-[200px]",
          isInvalid && "border-red-300 bg-red-50",
          isInactive && "border-yellow-300 bg-yellow-50"
        )}
        placeholder={placeholder}
        options={sortedOrganizations.map(org => ({
          value: org.id,
          label: `${org.type} - ${org.name} (${org.code})${!org.isActive ? ' [Inactive]' : ''}`
        }))}
      />
      
      {/* Validation indicator */}
      {showValidationIcon && (
        <>
          {isInvalid && (
            <AlertTriangleIcon 
              size={16} 
              className="text-red-500" 

            />
          )}
          {isInactive && (
            <AlertTriangleIcon 
              size={16} 
              className="text-yellow-500" 

            />
          )}
        </>
      )}
    </div>
  );
}
